import { createSlice } from '@reduxjs/toolkit';
import { uppercaseFirst } from 'shared/utils';

export const createCustomSlice = ({
    initialState,
    name,
    reducers,
    saga,
    ...rest
}) => {

    const defaultSetters = createDefaultSetters(initialState, name);
    const sagaReducers = createSagaReducers(saga);

    return createSlice({
        initialState,
        name,
        reducers: {
            ...defaultSetters,
            ...sagaReducers,
            ...reducers
        },
        ...rest
    });
};

export const createDefaultSetters = (initialState = {}, reducerName = '') => {
    const setters = {};
    Object.keys(initialState).forEach(key => {
        const name = `set${ uppercaseFirst(reducerName) }${ uppercaseFirst(key) }`;
        setters[name] = (state, { payload }) => {
            state[key] = payload;
        };
    });
    return setters;
};

export const createSagaReducers = list => {
    const sagaReducers = {};
    list.forEach(element => sagaReducers[element] = () => {});
    return sagaReducers;
};
